export default __webpack_public_path__ + "static/media/all_project_icon.9a664a12.svg";